import React from "react";
import PropTypes from "prop-types";

import SelectableElement from "./SelectableElement";
import SelectableSection from "./SelectableSection";
import ValuePlaceholder from "./ValuePlaceholder";

const CustomerSectionViewer = ({ invoiceData }) => {
  const { bilingualEnabled, customerSection } = invoiceData;

  return (
    <SelectableSection
      section="customerSection"
      isSelectable={customerSection.isSelectable}
    >
      <table width="100%" className="customer-table">
        <tbody>
          <tr>
            <td>
              {customerSection.fields
                .filter(field => field.visible)
                .sort((a, b) => a.order - b.order)
                .map((field, index) => (
                  <div
                    key={index}
                    className="customer-table-row"
                    style={{ display: "inline-flex", ...field.style }}
                  >
                    <SelectableElement
                      as="span"
                      id={`customerSection.fields[${index}].label.vi`}
                      stylePath={`customerSection.fields[${index}].labelStyle.vi`}
                      style={field.labelStyle.vi}
                    >
                      {field.label.vi}
                    </SelectableElement>
                    {bilingualEnabled && (
                      <SelectableElement
                        as="span"
                        id={`customerSection.fields[${index}].label.en`}
                        stylePath={`customerSection.fields[${index}].labelStyle.en`}
                        style={field.labelStyle.en}
                      >
                        &nbsp;{field.label.en}
                      </SelectableElement>
                    )}
                    <SelectableElement
                      as="span"
                      id={`customerSection.fields[${index}].delimiter`}
                      stylePath={`customerSection.fields[${index}].delimiterStyle`}
                      style={field.delimiterStyle}
                    >
                      {field.delimiter}&nbsp;
                    </SelectableElement>

                    <SelectableElement
                      as="span"
                      className="value-text"
                      id={`customerSection.fields[${index}].value`}
                      stylePath={`customerSection.fields[${index}].valueStyle`}
                      style={{
                        ...field.valueStyle,
                        borderBottom: customerSection.border.enabled
                          ? "1px dotted"
                          : "",
                      }}
                    >
                      <ValuePlaceholder placeholderKey={field.name}>
                        {field.defaultValue || field.value}
                      </ValuePlaceholder>
                    </SelectableElement>
                  </div>
                ))}

              {customerSection.fields.filter(field => field.visible).length <=
                0 && <div className="my-2"></div>}
            </td>
          </tr>
        </tbody>
      </table>
    </SelectableSection>
  );
};

CustomerSectionViewer.propTypes = {
  invoiceData: PropTypes.object,
};

export default CustomerSectionViewer;
